const scalar = (value) => Array.isArray(value) ? value[0] : value;

export function normalizeEventClassrooms(data) {
  const rows = Array.isArray(data) ? data : data?.turmas || [];
  return rows.map((classroom) => {
    const id = scalar(classroom?.TurmaID ?? classroom?.id);
    const name = scalar(classroom?.Nome ?? classroom?.NomeTurma ?? classroom?.name);
    if (id == null || id === "" || name == null || name === "") return null;
    return { ...classroom, TurmaID: String(id), Nome: String(name) };
  }).filter(Boolean);
}

export function validateEventFormDates(form) {
  const startsAt = new Date(form.startsAt);
  const registrationStartsAt = new Date(`${form.registrationStartsAt}T00:00:00`);
  const registrationEndsAt = new Date(`${form.registrationEndsAt}T23:59:59.999`);
  if ([startsAt, registrationStartsAt, registrationEndsAt].some((date) => Number.isNaN(date.getTime()))) {
    return "Preencha o início do evento e o período de inscrições.";
  }
  if (registrationEndsAt < registrationStartsAt) return "O fim das inscrições deve ser posterior ao início das inscrições.";
  if (registrationEndsAt > startsAt) return "As inscrições devem terminar até a data do evento.";
  if (form.endsAt && new Date(form.endsAt) < startsAt) return "O fim do evento deve ser posterior ao início.";
  return null;
}

export function eventApiError(error, fallback) {
  const validation = error?.response?.data?.details?.validationErrors;
  if (Array.isArray(validation) && validation.length) return validation.map((item) => item.message).join(" ");
  return error?.response?.data?.error || fallback;
}
